/* Smoozely editorial — enhance the existing Shopify gallery without external libraries. */
(() => {
  'use strict';
  function initialize(root = document) {
    root.querySelectorAll('[data-smo-product]:not([data-smo-eye-enhanced])').forEach(product => {
      product.dataset.smoEyeEnhanced = '1';
      const gallery = product.querySelector('[data-smo-gallery]');
      if (!gallery) return;
      const thumbs = [...gallery.querySelectorAll('[data-smo-gallery-thumb]')];
      const counter = gallery.querySelector('[data-smo-gallery-counter]');
      const updateCounter = () => {
        const available = thumbs.filter(t => !t.hidden);
        const active = available.findIndex(t => t.classList.contains('is-selected'));
        if (counter) counter.textContent = String(Math.max(1, active + 1)).padStart(2,'0') + ' / ' + String(Math.max(1,available.length)).padStart(2,'0');
      };
      const shift = direction => {
        const available = thumbs.filter(t => !t.hidden);
        if (!available.length) return;
        const index = available.findIndex(t => t.classList.contains('is-selected'));
        const next = available[(Math.max(0,index) + direction + available.length) % available.length];
        next?.click();
        updateCounter();
      };
      gallery.querySelector('[data-smo-gallery-prev]')?.addEventListener('click', () => shift(-1));
      gallery.querySelector('[data-smo-gallery-next]')?.addEventListener('click', () => shift(1));
      gallery.addEventListener('click', event => {
        if (event.target.closest('[data-smo-gallery-thumb]')) updateCounter();
      });
      gallery.addEventListener('smo:gallery-change', updateCounter);
      product.addEventListener('click', event => {
        if (event.target.closest('[data-smo-option-value]')) requestAnimationFrame(updateCounter);
      });
      updateCounter();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', e => initialize(e.target));
})();

/* Keep the quick-buy bar tied to the real Shopify product form and variant. */
(() => {
  'use strict';
  function setup(root=document) {
    root.querySelectorAll('[data-smo-sticky-buy]:not([data-smo-sticky-ready])').forEach(bar => {
      bar.dataset.smoStickyReady='1';
      const product=bar.closest('[data-smo-product]');
      const mainButton=product?.querySelector('[data-smo-add]');
      const form=mainButton?.closest('form');
      const quickButton=bar.querySelector('[data-smo-sticky-submit]');
      const quickPrice=bar.querySelector('[data-smo-sticky-price]');
      const quickColor=bar.querySelector('[data-smo-sticky-color]');
      const optionLabel=product?.querySelector('[data-smo-option-label]');
      const mainPrice=product?.querySelector('[data-smo-product-price]');
      if (!form || !mainButton || !quickButton) return;
      function sync() {
        quickButton.disabled=mainButton.disabled;
        quickButton.textContent=mainButton.disabled ? 'SOLD OUT' : 'ADD TO BAG';
        if(quickPrice && mainPrice) quickPrice.textContent=mainPrice.textContent;
        if(quickColor && optionLabel) quickColor.textContent=optionLabel.textContent.trim();
      }
      quickButton.addEventListener('click', () => {
        if(mainButton.disabled) return;
        sync();
        if (typeof form.requestSubmit==='function') form.requestSubmit(mainButton);
        else mainButton.click();
      });
      const observer=new IntersectionObserver(entries => {
        const e=entries[0];
        bar.classList.toggle('is-active',!e.isIntersecting && e.boundingClientRect.top < 0);
      }, {threshold:0});
      observer.observe(mainButton);
      const changes=new MutationObserver(sync);
      changes.observe(mainButton,{attributes:true,attributeFilter:['disabled'],childList:true,characterData:true,subtree:true});
      if(mainPrice) changes.observe(mainPrice,{childList:true,characterData:true,subtree:true});
      if(optionLabel) changes.observe(optionLabel,{childList:true,characterData:true,subtree:true});
      product.addEventListener('click', event => {
        if(event.target.closest('[data-smo-option-value]')) setTimeout(sync,0);
      });
      sync();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());
  else setup();
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();

/* Cart image resilience: missing line-image, CDN failure and product-photo fallback. */
(() => {
  'use strict';
  function initSmoozelyCartImageFallbacks(root = document) {
    root.querySelectorAll('[data-smo-cart-photo]:not([data-smo-cart-ready])').forEach(photo => {
      photo.dataset.smoCartReady = 'true';
      const image = photo.querySelector('img.smo-cart__image');
      const placeholder = photo.querySelector('.smo-cart__photo-placeholder');
      if (!image || !placeholder) return;
      const backup = photo.dataset.smoCartFallback || '';
      function showBackupOrPlaceholder() {
        if (backup && image.dataset.smoCartBackupTried !== 'true') {
          image.dataset.smoCartBackupTried = 'true';
          try {
            const current = new URL(image.currentSrc || image.src, window.location.href);
            const fallback = new URL(backup, window.location.href);
            if (current.pathname !== fallback.pathname) {
              image.removeAttribute('srcset');
              image.removeAttribute('sizes');
              image.src = backup;
              return;
            }
          } catch (_error) {
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = backup;
            return;
          }
        }
        image.hidden = true;
        placeholder.hidden = false;
      }
      image.addEventListener('error', showBackupOrPlaceholder);
      if (image.complete && image.naturalWidth === 0) showBackupOrPlaceholder();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSmoozelyCartImageFallbacks());
  } else {
    initSmoozelyCartImageFallbacks();
  }
  document.addEventListener('shopify:section:load', event => initSmoozelyCartImageFallbacks(event.target));
})();
